// src/pages/LanguageList.js
import React, { useEffect, useState } from "react";
import { useAuthCheck } from "../components/Auth";
import { api } from "../components/Api";
import Loading from "../components/Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

export default function LanguageList() {
    const [languages, setLanguages] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { checkToken } = useAuthCheck();

    useEffect(() => { checkToken(); }, [checkToken]);

    useEffect(() => {
        fetchLanguages();
    }, []);

    const fetchLanguages = async () => {
        setLoading(true);
        try {
            const res = await api.get("/languages");
            setLanguages(res.data);
        } catch (err) {
            console.error(err);
            alert("Erreur lors de la récupération des langues.");
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Voulez-vous vraiment supprimer cette langue ?")) return;

        try {
            await api.delete(`/languages/${id}`);
            setLanguages(languages.filter((lang) => lang.id !== id));
        } catch (err) {
            if (err.response && err.response.status === 409) {
                alert(err.response.data.message || "Impossible de supprimer cette langue car elle est utilisée.");
            } else {
                console.error(err);
                alert("Erreur lors de la suppression de la langue.");
            }
        }
    };

    const token = localStorage.getItem("token");

    if (!token || localStorage.getItem("role") > 2) {
        navigate("/");
    }

    return (
        <div className="container mx-auto p-6">
            <h1 className="text-2xl font-bold mb-4 dark:text-white">Liste des Langues</h1>

            <button
                onClick={() => navigate("/add-language")}
                className="bg-blue-400 hover:bg-blue-500 text-white font-semibold rounded px-4 py-2 mb-4"
            >
                Ajouter une langue
            </button>

            {loading ? (
                <Loading message="Chargement des langues..." />
            ) : (
                <div className="overflow-x-auto">
                    <table className="w-full border-collapse border text-sm text-center">
                        <thead className="bg-gray-100 dark:bg-gray-800">
                            <tr>
                                <th className="border px-2 py-1">Nom</th>
                                <th className="border px-2 py-1">Supprimer</th>
                            </tr>
                        </thead>
                        <tbody>
                            {languages.map((lang, index) => {
                                const bgColor = index % 2 === 0 ? "dark:bg-gray-600 bg-gray-050" : "dark:bg-gray-700 bg-gray-100";
                                return (
                                    <tr key={lang.id} className={`${bgColor}`}>
                                        <td className="border px-2 py-1">{lang.language_name}</td>
                                        <td className="border px-2 py-1">
                                            <button
                                                onClick={() => handleDelete(lang.id)}
                                                className="text-red-500 text-2xl"
                                            >
                                                <FontAwesomeIcon icon={faTrashCan} />
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
